/**
 *
 * @description ドメイン名からサブドメインを取り出す
 *
 * @example
 * ```
 * hogehoge.dev.booking.chillnn.com -> hogehoge
 * ```
 *
 */
export const extractSubdomainFromDomainName = (domainName: string): string => {
	const baseDomain = import.meta.env.VITE_BASE_DOMAIN ?? "";
	// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
	return domainName.replace(baseDomain, "");
};
